import { useTranslation } from '@/lib/i18n';
import { StatusPill } from '@/components/ui';
import { resolveSettlementStatus } from '@/lib/domain';

export interface SettlementRunStatusPillProps {
  status: string | null | undefined;
  runId?: string;
}

export const SettlementRunStatusPill = ({
  status,
  runId,
}: SettlementRunStatusPillProps) => {
  const { t } = useTranslation('settlement');
  const meta = resolveSettlementStatus(status, runId ? { runId } : undefined);
  return (
    <StatusPill
      variant={meta.badge}
      displayStatus={status}
      label={t(meta.i18nKey, status ?? '')}
      testId="settlement-status-pill"
    />
  );
};
